import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import StatsGrid from "../components/StatsGrid";
import DownloadSection from "../components/DownloadSection";
import HistoryTable from "../components/HistoryTable";
import { fetchStatsAndDownloads } from "../utils/fetchStatsAndDownloads";
import { handleDownload } from "../utils/handleDownload";

import "../styles/Dashboard.css";

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [usedToday, setUsedToday] = useState(0);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [downloadLink, setDownloadLink] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [downloadHistory, setDownloadHistory] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");

  const handleDownloadClick = () =>
    handleDownload({
      url,
      user,
      stats,
      usedToday,
      setLoading,
      setDownloadLink,
      setShowModal,
      setStats,
      setDownloadHistory,
      setUsedToday,
      setErrorModalMessage,
      setShowErrorModal,
    });

  useEffect(() => {
    if (user) {
      fetchStatsAndDownloads(user, setStats, setDownloadHistory, setUsedToday);
    }
  }, [user]);

  if (!stats) {
    return (
      <div className="loading-dashboard">
        <div className="spinner" />
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-wrapper">
      {/* Sidebar */}
      <Sidebar />

      <main className="main-content">
        {/* Header */}
        <Header />
        {/* StatsGrid */}
        <StatsGrid stats={stats} usedToday={usedToday} />
        {/* DownloadSection */}
        <DownloadSection
          url={url}
          setUrl={setUrl}
          loading={loading}
          handleDownload={handleDownloadClick}
          showModal={showModal}
          downloadLink={downloadLink}
          onCloseModal={async () => {
            setShowModal(false);
            await fetchStatsAndDownloads(
              user,
              setStats,
              setDownloadHistory,
              setUsedToday
            );
          }}
        />
        {showErrorModal && (
          <div className="modal-backdrop">
            <div className="modal">
              <div className="modal-icon">❌</div>
              <h2>Error</h2>
              <p>{errorModalMessage}</p>
              <button
                className="btn-close"
                onClick={() => setShowErrorModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}

        {/* HistoryTable */}
        <HistoryTable downloadHistory={downloadHistory} />
      </main>
    </div>
  );
}
